import theme from './theme/zh_TW';
import profile from './profile/zh_TW';
import member from './member/zh_TW';
import organization from './organization/zh_TW';
import console from './console/zh_TW';
import aws from './aws/zh_TW';
import activity from './activity/zh_TW';

export default {
  ...theme,
  ...profile,
  ...organization,
  ...console,
  ...member,
  ...aws,
  ...activity,
};
